/**@jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";

import { useNavigate } from "react-router-dom";

import Icon from "components/icon/icon";
import Card from "components/card/card";

import css from "./shows.module.css";

const ShowsShowCard = ({ data, onClick }) => {
  const navigate = useNavigate();

  const theme = useTheme();

  const handleToShow = () => {
    navigate(`/admin/shows/${data?.id}`);
  };

  const formatDateRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const options = { month: "long", day: "numeric", year: "numeric" };

    if (
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear()
    ) {
      return `${startDate.toLocaleDateString("en-US", {
        month: "long",
      })} ${startDate.getDate()}-${endDate.getDate()}, ${startDate.getFullYear()}`;
    } else {
      return `${startDate.toLocaleDateString(
        "en-US",
        options,
      )} - ${endDate.toLocaleDateString("en-US", options)}`;
    }
  };

  const formattedShowType =
    data?.show_type.charAt(0).toUpperCase() +
    data?.show_type.slice(1).toLowerCase();

  const intro = (
    <div className={css.intro} onClick={handleToShow}>
      <div className={css.title}>{data?.name}</div>
      <div className={css.info}>
        <span>{formatDateRange(data?.start_at, data?.end_at)}</span>
        <span>{formattedShowType}</span>
      </div>
    </div>
  );

  const btnEdit = (
    <div onClick={onClick} className={css.btn}>
      <Icon icon="Edit" stroke={theme?.button?.primary?.outlined?.svgColor} />
    </div>
  );

  const btnGo = (
    <div onClick={handleToShow} className={css.btn}>
      <Icon
        icon="ChevronRight"
        stroke={theme?.button?.primary?.outlined?.svgColor}
      />
    </div>
  );

  const infoActions = (
    <div className={css.infoActions}>
      {btnEdit}
      {btnGo}
    </div>
  );

  return (
    <Card>
      {intro}
      {infoActions}
    </Card>
  );
};

export default ShowsShowCard;
